var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"value":"app"}},[_c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[_c('UiLoader'),_c('UiToast'),_c('UiDialog'),_c('UiAmbientIndicator'),_c('router-view'),_c('BrowserValidate')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }